// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-intranet-layout__navbar',
    // #endregion
    // #region Computes
    computed: {
        mainMenuEntriesLeft() {
            return this.$host.store.getter("navigation/getMenu", "INTRANET").filter(e => e.alignment == 0);
        },
        currentUser() {
            return this.$host.store.get("session").currentUser;
        },
        userDisplayName() {
            return this.currentUser?.displayName ?? '';
        },
    }
    // #endregion
});
// #endregion
